const visitStatuses = {

  install (Vue, options) {
    Vue.prototype.VisitStatuses = {
      1: 'Pending',
      2: 'Confirmed',
      3: 'Waiting',
      4: 'In visit',
      5: 'After work',
      6: 'Finished',
      7: 'Un-reached',
      8: 'Late',
      9: 'Cancelled',
      PENDING: 1,
      CONFIRMED: 2,
      WAITING: 3,
      IN_VISIT: 4,
      AFTER_WORK: 5,
      FINISHED: 6,
      UN_REACHED: 7,
      LATE: 8,
      CANCELLED: 9,
      // PENDING_ALLOWING_STATUSES: [2, 3, 7],
      // CONFIRMED_ALLOWING_STATUSES: [3, 7],
      // UN_REACHED_ALLOWING_STATUSES: [2,3],
      // WAITING_ALLOWING_STATUSES: [4],
      // IN_VISIT_ALLOWING_STATUSES: [4],
      // WAITING_ALLOWING_STATUSES: [4],
      // WAITING_ALLOWING_STATUSES: [4],
      // WAITING_ALLOWING_STATUSES: [4],
      DOCTOR_ALLOWABLE_STATUSES: [3, 4],
      EMPLOYEE_AND_ADMIN_ALLOWABLE_STATUSES: [1, 2, 3, 4, 5, 6, 7, 8, 9],

    }
  }
}

export default visitStatuses



// WEBPACK FOOTER //
// ./src/constants/visitStatuses.js